import React, { useEffect, useState } from "react";
import { RCCButton, RCCGrid, RCCHierarchicalTree, RCCHookToast, RCCServicesApi } from "react-common-components";
import { IObject } from "react-common-components/dist/components/HierarchicalTree/interface";
import { useForm } from "react-hook-form";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import yup from "src/utils/yup/extensionMethods";
import { IParameterHierarchy, IPatba002Hierarchy } from "../interface";
import ParameterNode from "./parameterNode";

const ParametersHierarchyTree: React.FC<IParameterHierarchy> = ({
	groups
}) => {

	const { translate} = useTranslation();
	const [btnLoading, setbtnLoading] = useState(false);
	const { addToast} = RCCHookToast();
	const {
		register,
		control,
		formState:{errors},
		setValue,
		setError,
		clearErrors,
		reset,
		handleSubmit
	}= useForm();
    
	const [itens, setItens] = useState<IObject[]>(groups);

	const createSchema = (keys:string[]) => {
		const baseSchema = {} as any;
		keys.forEach((key) => {
			baseSchema[key] = yup.string()
				.required(translate("O valor do parâmetro é requerido"));
			
		});
		return yup.object().shape(baseSchema);
	};
	 
	const submitValues = async(data: any) => {
		try{
			
			clearErrors();
			const keys = Object.keys(data);
			if(keys.length === 0) return;

			setbtnLoading(true);
			const schema = createSchema(keys);
			const dataForm:any={};

			keys.forEach((key) => {
				dataForm[key] = data[key]?.value || data[key];
			});

			await schema.validate({...dataForm}, {
				abortEarly: false
			});

			const valuesDto:{parameterId:number,value:string}[] = [];
			keys.forEach((key) => {
				valuesDto.push({
					parameterId:Number(key.substring(10)),
					value:dataForm[key]
				});
			});

			await RCCServicesApi.postRequest({
				method: "parameters/SaveHierarchy",
				body: {valuesDto:[...valuesDto]}
			});
	
			addToast({
				color: "green",
				description: translate("Parâmetros salvos com sucesso"),
				title: translate("Sucesso")
			});

			setbtnLoading(false);
	
		}catch(err){
			setbtnLoading(false);
			if(getValidationErrors(err,setError)){
				addToast({
					color: "yellow",
					description: translate("Verifique os campos e tente novamente"),
					title: translate("Atenção")
				});
				return;
			}
	
			standardErrorMessages(err,  translate("Erro ao salvar parâmetros"), addToast);
		}
	};
	useEffect(() => {
		reset();
		setItens(groups);
	}, [groups]);

	return (
		<RCCGrid container style={{marginTop:"20px"}}>
			<RCCHierarchicalTree
				data={itens}
				styleInline={
					`width:100%;
                        .rst__node{
                            height: fit-content !important;
                    
                        }
						.rst__row{
							display:block;
						}
					`
				}
				canDrop={() => false}
				canDrag={() => false}
				generateNodeProps={({node}:any) => ({
					title: 
						<RCCGrid container item>
							{node.paa001Grupo ? 
								<Title 
									size="sm"
									color="purple"
									marginBottom={10}
									marginTop={10}
								>
									{`${node.paa001Grupo} - ${translate(node.paa001Descricao)}`}
								</Title>
								:
								<ParameterNode  
									parameter={node as IPatba002Hierarchy}
									control={control}
									register={register}
									errors={errors}
									setValue={setValue}
								/>
							}
						</RCCGrid>
				})}
			/>
			<RCCGrid container justifyContent="flex-end" style={{marginTop:"20px"}}>
				<RCCButton
					color="green"
					onClick={handleSubmit(submitValues)}
					loading={btnLoading}
					loadingText={translate("Carregando")}
				>
					{translate("Confirmar")}
				</RCCButton>
			</RCCGrid>
				
		</RCCGrid>
	);

};

export default ParametersHierarchyTree;
